module.exports = __webpack_public_path__ + "static/media/2024_SAAKC_12th_Anniversary_Flyer.105a13ce.png";